import ErrorUtils from '~/utils/error_utils';
import { Message } from 'element-ui';

export default {
    getVideo({state, commit}, payload) {
        commit('setIsLoading', true);

        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/oembed/get',
                data: payload,
                method: 'GET',
                global: false
            })
            .done((data) => {
                if (data.code) {
                    commit('updateVideoData', data);
                }
                resolve(data);
                commit('setIsLoading', false);
            })
            .fail((xhr) => {
                commit('setIsLoading', false);
                Message.error('Invalid video url');
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    }
}